// Pre-fills the access-request form with the visitor's IPv4 and IPv6 addresses.
// The IPv4-only and IPv6-only hostnames each report the address of the
// connection used to reach them, so asking both reveals both families.

async function fetchIp(host) {
  try {
    const response = await fetch(`https://${host}/ip`, { mode: "cors" });
    if (!response.ok) return null;

    const data = await response.json();
    return data.ip;
  } catch (error) {
    return null;
  }
}

async function prefillAddresses() {
  const field = document.getElementById("ip_addresses");
  if (!field) return;

  const addresses = new Set(
    field.value.split(/[\s,]+/).filter((value) => value.length > 0)
  );

  const hosts = [field.dataset.ipv4Host, field.dataset.ipv6Host].filter(Boolean);
  const found = await Promise.all(hosts.map(fetchIp));
  found.filter(Boolean).forEach((ip) => addresses.add(ip));

  field.value = Array.from(addresses).join("\n");
}

document.addEventListener("DOMContentLoaded", prefillAddresses);
